import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective, BsModalRef } from 'ngx-bootstrap/modal';
import {DataTableDirective} from 'angular-datatables';
import {Subject} from "rxjs";
import {BackendApiService} from '../services/backend-api.service';
import { BackendSocketService } from '../services/backend-socket.service';
import {ActivatedRoute, Router,NavigationEnd} from '@angular/router';
import { CommonService } from '../services/common.service';
import _ from "lodash";
import { NgForm }   from '@angular/forms';
import { interval } from 'rxjs'; 
import * as $ from 'jquery';
import * as moment from 'moment';

@Component({
  selector: 'app-endbadlaorder',
  templateUrl: './endbadlaorder.component.html',
  styleUrls: ['./endbadlaorder.component.scss']
})
export class EndbadlaorderComponent implements OnInit {
  @ViewChild('deleteModal') deleteModal: ModalDirective;
  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  endOrder:Boolean = false; 
  badlaOrderList = [];
  scriptFilter = [];
  filterBadla = [];
  overAllResult : any = 0;
  userId =  localStorage.getItem('userId');
  selectedBadla = "1";
  jsonData:any = [];
  constructor(private route: ActivatedRoute,
    private router: Router,
    private backendApiService: BackendApiService,
    private backendSocketService: BackendSocketService,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.getBadlaOrder();
    this.getPL()
    
  }

  getBadlaOrder(){
    let data = {
      "isOpen":false,
      "userId" : this.userId
    }
    this.backendApiService.getBadlaOrderGroup(data).subscribe(response => {
      if(response.status == true){
        this.badlaOrderList = response.data;
        this.filterBadla = response.data;
        console.log('filterDate',this.filterBadla);
        this.filterBadla.sort((a, b) => {
          // Convert the updatedAt date strings to Date objects
          const dateA = new Date(a['plDetail']['createdAt']);
          const dateB = new Date(b['plDetail']['createdAt']);
          console.log('dateA',dateA);
          console.log('dateB',dateB);

      
          // Compare the dates in descending order
          return dateB.getTime() - dateA.getTime();
      });
      console.log('this.filterBadla',this.filterBadla);

        this.scriptFilter = _.uniqBy(this.badlaOrderList, 'badlRefId');
        this.badlaOrderList.forEach(element => {
          let comexSellPrice = (element['endComexType'] == "sell") ? Number(element['endComexPrice']) : Number(element['comexPrice']);
          let comexBuyPrice = (element['endComexType'] == "sell") ? Number(element['comexPrice']) : Number(element['endComexPrice']);
          let comexQty = Number(element['comexQty']);
          let comexLotSize = (element['comexDetail'][0]) ? Number(element['comexDetail'][0]['lot_size']) : 0;
          let endDgcxPrice = Number(element['endDgcxPrice']);
          let comexEqu = (comexSellPrice - comexBuyPrice) * comexQty * comexLotSize;
          let comexResult = comexEqu  * 10000/endDgcxPrice;
          element.comexResult = comexResult.toFixed(2);          

          let mcxSellPrice = (element['endMcxType'] == "sell") ? Number(element['endMcxPrice']) : Number(element['mcxPrice']);
          let mcxBuyPrice = (element['endMcxType'] == "sell") ? Number(element['mcxPrice']) : Number(element['endMcxPrice']);
          let mcxQty = Number(element['mcxQty']);
          let mcxLotSize = (element['mcxDetail'][0]) ? Number(element['mcxDetail'][0]['lot_size']) : 0;
          let mcxResult = (mcxSellPrice - mcxBuyPrice) * mcxQty * mcxLotSize;
          element.mcxResult = mcxResult.toFixed(2);          

          let dgcxSellPrice = (element['endDgcxType'] == "sell") ? Number(element['endDgcxPrice']) : Number(element['dgcxPrice']);
          let dgcxBuyPrice = (element['endDgcxType'] == "sell") ? Number(element['dgcxPrice']) : Number(element['endDgcxPrice']);
          let dgcxQty = Number(element['dgcxQty']);
          let dgcxLotSize = (element['dgcxDetail'][0]) ? Number(element['dgcxDetail'][0]['lot_size']) : 0;                    
          let dgcxEqu = (dgcxSellPrice - dgcxBuyPrice) * dgcxQty * dgcxLotSize;
          let dgcxResult = dgcxEqu  * 10000/endDgcxPrice;
          element.dgcxResult = dgcxResult.toFixed(2); 
          let sum = comexResult + mcxResult + dgcxResult;
          element.totalResult = sum.toFixed(2);
        });
        setTimeout(() => {
            // ADD THIS
            this.dtTrigger.next();
            this.dtOptions = {
              pagingType: 'full_numbers'
            };
                    
        }, 100);
        
      }else{
        this.badlaOrderList = [];
      }
    })
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
   }

  getPL(){
    let data = {
      "isOpen":false,
      "userId":this.userId
    }
    this.backendApiService.getOrderPL(data).subscribe(response => {
      if(response.status == true){
        this.overAllResult = Number(response.data).toFixed(2);
      }
    })
  }


  searchBadlaScript(){
    if(this.selectedBadla){
      let badlaId = this.selectedBadla;
      if(badlaId !== "1"){
        this.filterBadla = _.filter(this.badlaOrderList, function (dt) {
          return dt.badlRefId == badlaId;
        })
      }else{
        this.filterBadla = this.badlaOrderList;
      }
      this.filterBadla.forEach(element => {
        let comexSellPrice = (element['endComexType'] == "sell") ? Number(element['endComexPrice']) : Number(element['comexPrice']);
        let comexBuyPrice = (element['endComexType'] == "sell") ? Number(element['comexPrice']) : Number(element['endComexPrice']);
        let comexQty = Number(element['comexQty']);
        let comexLotSize = Number(element['comexDetail'][0]['lot_size']);
        let endDgcxPrice = Number(element['endDgcxPrice']);
        let comexEqu = (comexSellPrice - comexBuyPrice) * comexQty * comexLotSize;
        let comexResult = comexEqu  * 10000/endDgcxPrice;
        element.comexResult = comexResult.toFixed(2);          

        let mcxSellPrice = (element['endMcxType'] == "sell") ? Number(element['endMcxPrice']) : Number(element['mcxPrice']);
        let mcxBuyPrice = (element['endMcxType'] == "sell") ? Number(element['mcxPrice']) : Number(element['endMcxPrice']);
        let mcxQty = Number(element['mcxQty']);
        let mcxLotSize = Number(element['mcxDetail'][0]['lot_size']);
        let mcxResult = (mcxSellPrice - mcxBuyPrice) * mcxQty * mcxLotSize;
        element.mcxResult = mcxResult.toFixed(2);          

        let dgcxSellPrice = (element['endDgcxType'] == "sell") ? Number(element['endDgcxPrice']) : Number(element['dgcxPrice']);
        let dgcxBuyPrice = (element['endDgcxType'] == "sell") ? Number(element['dgcxPrice']) : Number(element['endDgcxPrice']);
        let dgcxQty = Number(element['dgcxQty']);
        let dgcxLotSize = Number(element['dgcxDetail'][0]['lot_size']);                    
        let dgcxEqu = (dgcxSellPrice - dgcxBuyPrice) * dgcxQty * dgcxLotSize;
        let dgcxResult = dgcxEqu  * 10000/endDgcxPrice;
        element.dgcxResult = dgcxResult.toFixed(2); 
        let sum = comexResult + mcxResult + dgcxResult;
        element.totalResult = sum.toFixed(2);
      });
      let data = {
        "isOpen":false,
        "userId":this.userId,
        "badlRefId" : (badlaId !== "1")?badlaId:null
      }
      this.backendApiService.getOrderPL(data).subscribe(response => {
        if(response.status == true){
          console.log('response.data+++++++',response.data);
          this.overAllResult = Number(response.data).toFixed(2);
        }
      })      
    }
  }

  clearBadlaScript(){

  }

  closeDeleteBadlaOrder(){
    this.deleteModal.hide();
  }

  deleteBadlaOrder(){
    let data = {
      "userId":this.userId
    }
    this.backendApiService.deleteAllDetele(data).subscribe(response => {
      if(response['status'] == true){
        this.deleteModal.hide();
        this.getBadlaOrder();
        this.getPL();
      }
    })
  }

  clearAllOpenModal(){
    this.deleteModal.show();
  }
  downloadAsPDF(){
    let count = 0;
    console.log('this.filterBadla+++++++++',this.filterBadla);
    let headerKey = ['CREATEDDATE', 'UPDATEDDATE','DESCRIPTION' ,'AMOUNT'];
    let csvName = 'settlement report';
    let dataTemps = this.filterBadla.map(transaction => {
      let dataArr ={
        CREATEDDATE:moment(transaction.createdAt).format("YYYY-MM-DD"),
        UPDATEDDATE :moment(transaction['plDetail']['createdAt']).format("YYYY-MM-DD"),
        DESCRIPTION : transaction['reference'] + transaction['settingName'],
        AMOUNT : transaction['plDetail']['CalculateBalance']
      }
      count++;
      this.jsonData.push(dataArr);
      let csvName = 'settlement report';
      if(this.filterBadla.length == count) {
        this.commonService.downloadFile(this.jsonData, headerKey,csvName,"Settlement Report",this.overAllResult);
      }
    })
    
  }

}
